import { PropsWithChildren, ReactElement } from 'react';
import { TableHead, styled } from '@mui/material';

const StyledTableHead = styled(TableHead)(({ theme }) => ({
    '&& .MuiTableCell-head': {
        ...theme.typography.body1,
        backgroundColor: theme.palette.grey[900],
        color: theme.palette.common.white,
        height: 56,
        padding: theme.spacing(2),
    },
}));

export const SupplierTableHead = (props: PropsWithChildren): ReactElement => {
    const { children, ...tableHeadProps } = props;
    return <StyledTableHead {...tableHeadProps}>{children}</StyledTableHead>;
};
